import { faClock, faServer } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Skeleton } from 'primereact/skeleton'
import React, { Fragment } from 'react'
import { displayIslamicDate } from '../../../../asstes/js/utils'

export default function AssetDetailsCard({ loading, auction, item }) {
    return (
        <Fragment>

            {
                loading
                    ?
                    <Skeleton className="relative !h-[220px] mb-3 rounded-[10px]"></Skeleton>
                    :
                    <div className='mb-10'>

                        <div className='flex items-center mb-4'>

                            <div className='min-w-[21px] h-[21px] flex items-center justify-center bg-[#F0F0F0] rounded-[3px] me-3'>

                                <FontAwesomeIcon icon={faServer} className='text-[var(--secondary-text-color)] text-[13px]' />

                            </div>

                            <h3 className='font-medium text-[15px]'>
                                عدد الأصول
                                <span className='mx-1'>:</span>
                                <span>{item?.main_sub_pivot?.length}</span>
                            </h3>

                        </div>

                        <div className='flex items-center mb-4'>

                            <div className='min-w-[21px] h-[21px] flex items-center justify-center bg-[#F0F0F0] rounded-[3px] me-3'>

                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                    <path d="M10.9453 3.70313C10.7813 3.70313 10.6406 3.70312 10.4766 3.72656C10.2656 3.75 10.0781 3.79687 9.9375 3.9375C9.89063 3.98437 9.84375 4.00781 9.82031 4.07812C9.75 4.19531 9.70313 4.33594 9.70313 4.47656C9.70313 4.61719 9.67969 4.78125 9.67969 4.92188V6.65625C9.65625 6.65625 9.65625 6.65625 9.63281 6.63281C9.30469 6.42187 8.95312 6.21094 8.625 5.97656C8.17969 5.69531 7.73438 5.39062 7.28906 5.10937C6.72656 4.73437 6.16406 4.38281 5.57812 4.00781C5.46094 3.9375 5.32031 3.84375 5.20313 3.79688C5.08594 3.75 4.96875 3.70313 4.85156 3.70313C4.73438 3.70313 4.59375 3.70312 4.47656 3.72656C4.33594 3.75 4.21875 3.82031 4.125 3.89063C4.03125 3.9375 3.98437 4.03125 3.9375 4.125C3.89062 4.26563 3.86719 4.40625 3.86719 4.54687V5.0625C3.86719 6.98438 3.86719 8.92969 3.89063 10.8516V11.1562C3.89063 11.2031 3.89062 11.2031 3.9375 11.2031H4.125C4.28906 11.2031 4.45313 11.2031 4.61719 11.1562C4.92188 11.0625 5.17969 10.8281 5.22656 10.4297C5.22656 10.2422 5.25 10.0547 5.25 9.86719V7.85156C5.27344 7.85156 5.27344 7.875 5.29688 7.875C5.39063 7.94531 5.46094 7.99219 5.55469 8.0625C6.375 8.64844 7.21875 9.23438 8.03906 9.84375L9.51562 10.8984C9.65625 10.9922 9.79688 11.0859 9.9375 11.1562C10.0313 11.2031 10.125 11.2266 10.2188 11.2266C10.4062 11.2266 10.5703 11.1563 10.7344 11.0625C10.875 10.9688 10.9688 10.8281 10.9922 10.6406C11.0156 10.5469 11.0156 10.4531 11.0156 10.3594C11.0156 8.55469 11.0391 6.75 11.0391 4.92188V3.77344C10.9922 3.70313 10.9922 3.70313 10.9453 3.70313ZM9.63281 9.23438C9.63281 9.28125 9.60938 9.32813 9.5625 9.35156C9.51562 9.375 9.46875 9.375 9.42188 9.32812C9.28125 9.23438 9.14063 9.14062 9.02344 9.04688C8.34375 8.60156 7.66406 8.13281 6.98438 7.6875C6.51562 7.35938 6.04688 7.05469 5.57812 6.72656C5.50781 6.67969 5.4375 6.63281 5.36719 6.5625C5.27344 6.49219 5.22656 6.42187 5.22656 6.30469V6.1875C5.22656 6 5.22656 5.78906 5.25 5.60156C5.25 5.55469 5.25 5.50781 5.27344 5.46094C5.29688 5.41406 5.32031 5.39062 5.34375 5.36719C5.39062 5.34375 5.4375 5.34375 5.48438 5.36719C5.57812 5.4375 5.67188 5.48438 5.76563 5.55469C6.375 5.95313 6.98438 6.375 7.59375 6.77344C8.13281 7.125 8.64844 7.5 9.1875 7.85156C9.30469 7.92188 9.39844 7.99219 9.51562 8.08594C9.60938 8.13281 9.65625 8.20312 9.63281 8.32031V9.23438Z" fill="var(--dark-gray-color)" />
                                </svg>

                            </div>

                            <h6 className='font-medium text-[15px]'>
                                اسم المزاد
                                <span className='mx-1'>:</span>
                                <span className='text-[var(--gray-color)]'>{auction?.auction_title} </span>
                            </h6>

                        </div>

                        <div className='flex items-center mb-4'>

                            <div className='min-w-[21px] h-[21px] flex items-center justify-center bg-[#F0F0F0] rounded-[3px] me-3'>

                                <FontAwesomeIcon icon={faClock} className='text-[var(--secondary-text-color)] text-[13px]' />

                            </div>

                            <h6 className='font-medium text-[11px]'>

                                <span className='text-[var(--gray-color)]'>يبدأ {auction?.higri_start_date}</span>

                            </h6>

                            <h6 className='text-[var(--secondary-text-color)] font-medium text-[11px] sm:text-[13px] sm:ms-4'>
                               {auction?.start_date?.split(' ')[0]} م
                            </h6>
                        </div>

                        <div className='flex items-center mb-4'>

                            <div className='min-w-[21px] h-[21px] flex items-center justify-center bg-[#F0F0F0] rounded-[3px] me-3'>

                                <FontAwesomeIcon icon={faClock} className='text-[var(--secondary-text-color)] text-[13px]' />

                            </div>

                            <h6 className='font-medium text-[11px]'>

                                <span className='text-[var(--gray-color)]'>ينتهي {auction?.higri_end_date}</span>

                            </h6>

                            <h6 className='text-[var(--secondary-text-color)] font-medium text-[11px] sm:text-[13px] sm:ms-4'>
                               {auction?.end_date?.split(' ')[0]} م
                            </h6>
                        </div>
    

                        {/* {displayIslamicDate(auction?.start_date?.split(' ')[0], 'start')}

                        {displayIslamicDate(auction?.end_date?.split(' ')[0], 'end')} */}

                    </div>
            }

        </Fragment>
    )
}
